import React from "react";
import PropTypes from "prop-types";
import ConnectedResetPasswordEmailButton from "./ConnectedResetPasswordEmailButton";
import ConnectedSubmit from "./ConnectedSubmit";
import ConnectedEmailAndPassword from "./ConnectedEmailAndPassword";
import PasswordConfirm from "./PasswordConfirm";
import ConnectedWantToLogInButton from "./ConnectedWantToLogInButton";

const AccountPageContent = ({
    displayConfirmPasswordField,
    displayAccountForm,
}) => (
    <div className="account-page-content grid">
        {/* The form that contains the email, password, confirm password fields */}
        {displayAccountForm && (
            <>
                <div className="col col--12 -padding-top--0">
                    <ConnectedEmailAndPassword />
                </div>
                {displayConfirmPasswordField && (
                    <div className="col col--12 -padding-top--0">
                        <PasswordConfirm />
                    </div>
                )}
                <div className="col col--12 -padding-top--0">
                    <ConnectedSubmit />
                </div>
            </>
        )}
        <ConnectedResetPasswordEmailButton />
        <ConnectedWantToLogInButton />
    </div>
);

AccountPageContent.propTypes = {
    displayConfirmPasswordField: PropTypes.bool.isRequired,
    displayAccountForm: PropTypes.bool.isRequired,
};

export default AccountPageContent;
